<!-- <template>
  <div class="breadcrumb-back">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item class="title">
        {{ title }}
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>
<script>
export default {
  name: 'Breadcrumb',
  props:{
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
        
    }
  },
  methods:{
  }
}
</script>
<style lang="css" scoped>
.breadcrumb-back {
  height: 40px;
}
.breadcrumb {
  background-image: url('@/assets/images/u458.png');
  background-size: cover; /* 背景图片覆盖整个元素 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center;
  height: 100%;
  display: flex;
  align-items: center;
  background-color: #e4e7ed;
  padding-left: 20px;
  padding-top: 2.5px;
  margin-top: -5px;
}
::v-deep .breadcrumb .el-breadcrumb__inner.is-link {
  font-weight: 400 !important;
}
::v-deep .breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  font-weight: bold !important;
}
</style> -->
<template>
  <div class="breadcrumb-back">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
    <el-breadcrumb-item 
      v-for="(item, index) in breadcrumbList" 
      :key="index"
      :to="item.path ? { path: item.path } : null"
    >
    <!-- :to="item.path || null" -->
      {{ item.title }}
    </el-breadcrumb-item>
  </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'BreadcrumbNav',
  computed: {
    breadcrumbList() {
      return (this.$route.meta && this.$route.meta.breadcrumb) || []
    }
  }
}
</script>
<style lang="css" scoped>
.breadcrumb-back {
  height: 40px;
  background: #F4F8FF;
  border-bottom: 1px solid #D6E6FF;
}
.breadcrumb {
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 20px;
  max-width: var(--gs-main-width, 1250px);
  margin: 0 auto;
}
::v-deep .breadcrumb .el-breadcrumb__inner.is-link {
  font-weight: 400 !important;
  color: #5B6B82 !important;
}
::v-deep .breadcrumb .el-breadcrumb__inner.is-link:hover {
  color: #0165FF !important;
}
::v-deep .breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  font-weight: 600 !important;
  color: #0165FF !important;
}
</style>